import React from 'react';
import './SnowAnimation.css';

export default function SnowAnimation({ isActive }) {
  if (!isActive) return null;

  // Create multiple snowflakes with different sizes and speeds
  const snowflakes = Array.from({ length: 50 }, (_, i) => (
    <div
      key={i}
      className="snowflake"
      style={{
        left: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 5}s`,
        animationDuration: `${5 + Math.random() * 10}s`,
        opacity: 0.3 + Math.random() * 0.7,
        fontSize: `${5 + Math.random() * 10}px`,
      }}
    >
      ❄
    </div>
  ));

  return <div className="snow-container">{snowflakes}</div>;
}


